import { useCallback, useEffect, useState } from 'react';

const DAY_MS = 24 * 60 * 60 * 1000;

const readCookie = name =>
  document.cookie
    .split('; ')
    .map(c => c.split('='))
    .find(([key]) => key === name)?.[1];

/**
 * A notice someone can close for a while (the top bar's beta notice: 14 days).
 *
 * Visible on the server and in the first render, so the server's markup already makes room for
 * it and the page doesn't jump down after hydration. Once in the page, a visitor who closed it
 * within `days` doesn't see it (the `name` cookie). `dismiss` hides it and sets the cookie.
 *
 * @returns {[boolean, Function]} [isVisible, dismiss]
 */
const useCookieDismissal = (name, days) => {
  const [isVisible, setVisible] = useState(true);

  useEffect(() => {
    if (readCookie(name) === '1') {
      setVisible(false);
    }
  }, [name]);

  const dismiss = useCallback(() => {
    const expires = new Date(Date.now() + days * DAY_MS).toUTCString();
    document.cookie = `${name}=1; path=/; expires=${expires}`;
    setVisible(false);
  }, [name, days]);

  return [isVisible, dismiss];
};

export default useCookieDismissal;
